import * as ActionTypes from '../ActionTypes';

const componentInitialState = {
    isLoadingEcmsComp: false,
    ecms_components_data: [],
    success: false,
    error: false,
}

export const EcmsConfigFinanceReducer = function (state = componentInitialState, action) {
    switch (action.type) {
        case ActionTypes.ECMS_COMPONENTS_GET_REQUEST:
            return {
                ...state,
                isLoadingEcmsComp: true,
                success: false,
                error: false,
                ecms_components_data: []
            };
        case ActionTypes.ECMS_COMPONENTS_ADD_REQUEST:
        case ActionTypes.ECMS_COMPONENTS_UPDATE_REQUEST:
        case ActionTypes.ECMS_COMPONENTS_DELETE_REQUEST:
            return {
                ...state,
                isLoadingEcmsComp: true,
                success: false,
                error: false,
            };
        case ActionTypes.ECMS_COMPONENTS_GET_SUCCESS:
        case ActionTypes.ECMS_COMPONENTS_ADD_SUCCESS:
        case ActionTypes.ECMS_COMPONENTS_UPDATE_SUCCESS:
        case ActionTypes.ECMS_COMPONENTS_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingEcmsComp: false,
                success: true,
                successMessage: action.payload?.message,
                ecms_components_data: action?.payload?.data?.data
            };
        case ActionTypes.ECMS_COMPONENTS_GET_ERROR:
        case ActionTypes.ECMS_COMPONENTS_ADD_ERROR:
        case ActionTypes.ECMS_COMPONENTS_UPDATE_ERROR:
        case ActionTypes.ECMS_COMPONENTS_DELETE_ERROR:
            return {
                ...state,
                isLoadingEcmsComp: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };

        default:
            return state;
    }
}
